import React from 'react';
import { LicenseContainer } from 'pages/Shared/LicenseInfo';
import ManagerLayout from 'components/Layout/Manager/ManagerLayout';

export const ManagerLicenseInfoComponent = () => {
  return (
    <ManagerLayout>
      <div className="dealer-license-info">
        <LicenseContainer />
      </div>
    </ManagerLayout>
  );
};
